import { languages } from '@/router/globals.js'

const ManageTranslations = {
  data() {
    return {
      l10nDefaults: [],
    }
  },
  methods: {
    clearProps(obj) {
      Object.keys(obj).forEach((item) => {
        switch (typeof obj[item]) {
          case 'string':
            obj[item] = ''
            break
          case 'object':
            // If array
            if (Array.isArray(obj[item])) {
              // If array is not empty
              if (obj[item].length > 0) {
                this.clearProps(obj[item])
              } else {
                obj[item] = []
              }
              // If object
            } else {
              if (Object.keys(obj[item]).length > 0) {
                this.clearProps(obj[item])
              } else {
                obj[item] = {}
              }
            }
            break
        }
      })
    },
    addTranslation(lang, transform = true) {
      lang = lang.toLowerCase()

      // Copy keys from defaults
      let translation = JSON.parse(JSON.stringify(this.l10nDefaults))

      // Clear translations
      this.clearProps(translation)
      translation = { ...translation, lang, status: 'published' }

      // Push to list of translations
      this.item.l10n.push(translation)
      if (transform) this.transformTranslationData(this.item.l10n)

      // Redirect to new translation
      this.$router.push({ query: { ...this.$route.query, lang: lang } })
    },

    removeTranslation(lang, prompt = true, transform = true) {
      lang = lang.toLowerCase()

      // Get the language name from global list of languages, display in confirmation box
      const curLang = languages[languages.findIndex((x) => x.value === lang)].label.toLowerCase()

      const removeLang = () => {
        const index = this.item.l10n.findIndex((x) => x.lang === lang)
        this.item.l10n.splice(index, 1)
        if (transform) this.transformTranslationData(this.item.l10n)

        lang = this.item.l10n[0].lang
        if (prompt) this.$router.push({ query: { ...this.$route.query, lang: lang } })
      }

      if (prompt && confirm(`Are you sure you want to remove the ${curLang} translation for this item?`)) {
        removeLang()
      } else if (prompt === false) {
        removeLang()
      }
    },

    translationURL(translation) {
      return {
        query: {
          ...this.$route.query,
          lang: translation.toLowerCase(),
        },
      }
    },
  },
  mounted() {
    this.l10nDefaults = JSON.parse(JSON.stringify(this.item.l10n[0]))
  },
}

export default ManageTranslations
